export const TESTIMONIALS = [
  {
    id: 1,
    name: "Arthur D.",
    role: "Retired Architect",
    text: "I thought my golfing days were over because of my knees. The M12-1 gave me my game back — it’s incredibly stable and easy to get on and off.",
    rating: 5
  },
  {
    id: 2,
    name: "Martha S.",
    role: "Club Champion '22",
    text: "The battery life is excellent. I can do 36 holes without stressing about charging. Highly recommended for anyone who wants independence on the course.",
    rating: 5
  },
  {
    id: 3,
    name: "James P.",
    role: "Senior League Director",
    text: "Our club bought a small fleet. They’re gentle on the grass and the members love them — simple controls and a smooth ride.",
    rating: 5
  }
];
